import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MDStock } from 'src/app/interfaces/api/product';
import { CheckoutItem } from 'src/app/pages/checkout/checkout.page';
import { encodeQueryParam, transformWeight } from 'src/helpers';

@Component({
  selector: 'app-checkout-item',
  templateUrl: './checkout-item.component.html',
  styleUrls: ['./checkout-item.component.scss'],
})
export class CheckoutItemComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() isLastItem: boolean;
  @Input() checkoutItem: CheckoutItem;
  @Output() changeAmount = new EventEmitter();

  selectedWarehouse: MDStock;
  base_discount: number;
  price: number;
  price_discounted: number;
  weight: string;

  constructor(private router: Router) {}

  ngOnInit() {
    console.log(this.checkoutItem);
    const stock = this.checkoutItem?.product?.MdStock?.find(
      s => s.id_mh_warehouse === this.checkoutItem?.id_mh_warehouse,
    );
    this.weight = transformWeight(this.checkoutItem.product.weight);
    this.base_discount = Number((stock ?? this.checkoutItem?.product)?.base_discount);
    this.price = (stock ?? this.checkoutItem?.product)?.ppn_price ?? (stock ?? this.checkoutItem?.product)?.price;
    this.price_discounted = this.price * (1 - this.base_discount / 100);
  }

  onChangeAmount(mode: 'increase' | 'decrease') {
    this.changeAmount.emit({ cartId: this.checkoutItem.cartId, productId: this.checkoutItem.product.id, mode });
  }

  qtyDisplay(num: number) {
    const isOneDigit = num?.toString().length === 1;

    if (isOneDigit) {
      return '0' + num;
    }

    return num;
  }

  goToProductDetailPage() {
    this.router.navigate(['product-detail', this.checkoutItem.product.id], {
      queryParams: {
        selectedWarehouseId: encodeQueryParam(this.checkoutItem.product.id_mh_warehouse),
      },
    });
  }
}
